// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__3of9K","addWidgetButton":"Header_addWidgetButton__uSsaF","dashboardTabs":"Header_dashboardTabs__201hf","active":"Header_active__3jqkE"};